import { render, staticRenderFns } from "./AdminSwitcher.vue?vue&type=template&id=9613419a&"
import script from "./AdminSwitcher.vue?vue&type=script&lang=js&"
export * from "./AdminSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle})
